(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/challenge/assets/javascripts/components/coupon/wager.js') >= 0) return;  svs.modules.push('/modules/challenge/assets/javascripts/components/coupon/wager.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }

const _ReactRouterDOM = ReactRouterDOM,
  Redirect = _ReactRouterDOM.Redirect,
  withRouter = _ReactRouterDOM.withRouter;
const formatDate = svs.components.lbUtils.helpers.formatDate.formatDate;
const createNewWager = svs.components.payment.createWager.createWager;
const wagerPaymentFlow = svs.components.wagerPaymentFlow;
const standardFlow = wagerPaymentFlow.standardFlow,
  marketplaceFlow = wagerPaymentFlow.marketplaceFlow,
  executePayment = wagerPaymentFlow.executePayment;
const groupTypes = svs.components.marketplaceData.constants.groupTypes;

const log = new svs.core.log.Logger('trinidad.challenge');
const resolveMarketplaceBetProperties = () => {
  const betProps = ['GROUP'];
  if (svs.challenge.data.isRetailerAdmin) {
    betProps.push('GROUP_B2C');
  }
  return betProps;
};
const convertToOutcomes = {
  1: 0,
  X: 1,
  2: 2
};
const getMarketplaceAccount = svs.challenge.helpers.getMarketplaceAccount;
const createWager = data => ({
  bagType: 0,
  bets: [{
    betAmountSalesGroup1: svs.utils.format.CurrencyAsJupiterString(data.boardData.betSum),
    betAmountSalesGroup2: '0,00',
    betProperties: getMarketplaceAccount() ? resolveMarketplaceBetProperties() : [],
    drawNum: data.boardData.drawNumber,
    game1X2Boards: [{
      boardData: data.boardData.boardData,
      boardProps: data.boardProps ? [data.boardProps] : [],
      systemNum: 1,
      systemType: [data.boardData.systemType],
      uRowData: [0, 0, 0, 0, 0, 0, 0, 0]
    }],
    numDraws: 1,
    productId: 'TMIX',
    rowPriceMulti: data.boardData.rowPriceMulti
  }],
  crc: 0,
  marketInfo: 0,
  valid: data.boardData.valid
});
class PayWager extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "state", {
      redirect: false
    });
    this.onPaySuccess = this.onPaySuccess.bind(this);
    this.onPayError = this.onPayError.bind(this);
    this.onClickImpossibleRows = this.onClickImpossibleRows.bind(this);
  }
  componentDidUpdate(prevProps) {
    const _this$props = this.props,
      isPaymentInitialized = _this$props.isPaymentInitialized,
      boardData = _this$props.boardData;
    if (!prevProps.isPaymentInitialized && isPaymentInitialized) {
      this.initPayment(boardData);
    }
  }
  componentWillUnmount() {
    const cancelPayment = this.props.cancelPayment;
    const impossibleRowEl = document.querySelector('.impossible-rows-read-more');
    if (impossibleRowEl) {
      impossibleRowEl.removeEventListener('click', this.onClickImpossibleRows);
    }

    svs.components.Modal.hide();
    cancelPayment();
  }
  initPayment(boardData) {
    this.finalizePayment(boardData);
  }
  async finalizePayment(boardData) {
    const _this$props2 = this.props,
      draw = _this$props2.draw,
      coupon = _this$props2.coupon,
      paymentSuccess = _this$props2.paymentSuccess,
      cancelPayment = _this$props2.cancelPayment,
      clearCoupon = _this$props2.clearCoupon;
    const marketplaceAccount = getMarketplaceAccount();
    const productId = draw.productId,
      drawNumber = draw.drawNumber,
      minRowPrice = draw.rowPrice;
    const chosenBetPrice = coupon.chosenBetPrice,
      xpertenMode = coupon.xpertenMode;
    const wager = createNewWager().addBet(productId, bet => {
      bet.setDrawNumber(drawNumber);
      bet.setRowPrice(chosenBetPrice);
      bet.setRowPriceMulti(chosenBetPrice / parseInt(minRowPrice, 10));
      bet.addBoard(wagerBoard => {
        if (xpertenMode) {
          wagerBoard.addBoardProperty(xpertenMode);
        }
        boardData.boardData.forEach(outcomes => {
          const value = outcomes.split('').map(outcome => convertToOutcomes[outcome]);
          wagerBoard.addOutcomes(value);
        });
      });
    });
    const isSelfService = svs.utils.ns.isNamespace('svs.core.config.data.svsconfig.isSelfService') ? svs.core.config.data.svsconfig.isSelfService : false;
    if (isSelfService && wagerPaymentFlow.selfServiceFlow) {
      const regCloseTime = formatDate(draw.regCloseTime, true, true);
      const wagerCount = await wagerPaymentFlow.selfServiceFlow.createSelfServicePaymentFlow({
        wagers: [wager],
        regCloseTimes: [regCloseTime]
      });
      if (!wagerCount) {
        cancelPayment();
        return;
      }
      clearCoupon(draw.drawNumber);
      paymentSuccess();
      return;
    }
    let paymentBuilder;
    if (marketplaceAccount) {
      var _marketplaceAccount$s;
      const commissionPercent = (_marketplaceAccount$s = marketplaceAccount.selectedCommissionPercent) !== null && _marketplaceAccount$s !== void 0 ? _marketplaceAccount$s : marketplaceAccount.commissionPercent;
      wager.setCommissionPercent(commissionPercent);
      wager.setActivatedDrawId(parseInt(marketplaceAccount.activatedDrawId, 10));
      wager.setRole(commissionPercent ? groupTypes.RETAILER : groupTypes.PRIVATE);
      paymentBuilder = marketplaceFlow.createMarketplacePaymentFlow({
        config: {
          haltPaymentOnException: true
        },
        wagers: [wager]
      });
    } else {
      paymentBuilder = standardFlow.createStandardPaymentFlow({
        config: {
          haltPaymentOnException: true
        },
        wagers: [wager]
      });
    }
    const _await$executePayment = await executePayment.executePayment(paymentBuilder),
      _await$executePayment2 = _slicedToArray(_await$executePayment, 2),
      error = _await$executePayment2[1];
    if (error) {
      cancelPayment();
      return;
    }
    clearCoupon(drawNumber);
    this.setState({
      redirect: true
    });
    paymentSuccess();
  }
  onPaySuccess(data) {
    var _data$wagerAmounts, _data$CreateWagerRepl, _this$wager, _this$wager2;
    const _this$props3 = this.props,
      draw = _this$props3.draw,
      clearCoupon = _this$props3.clearCoupon,
      updateAccountBalance = _this$props3.updateAccountBalance,
      paymentSuccess = _this$props3.paymentSuccess;
    const originalAmount = parseInt(this.wager.bets[0].betAmountSalesGroup1, 10);
    const betAmount = parseInt(data.wagerAmounts ? (_data$wagerAmounts = data.wagerAmounts) === null || _data$wagerAmounts === void 0 ? void 0 : _data$wagerAmounts.betAmount : data === null || data === void 0 || (_data$CreateWagerRepl = data.CreateWagerReply) === null || _data$CreateWagerRepl === void 0 ? void 0 : _data$CreateWagerRepl.betAmount, 10);
    const diffAmount = originalAmount - betAmount;
    const impossibleRows = diffAmount / ((_this$wager = this.wager) === null || _this$wager === void 0 || (_this$wager = _this$wager.bets[0]) === null || _this$wager === void 0 ? void 0 : _this$wager.rowPriceMulti) / (this === null || this === void 0 || (_this$wager2 = this.wager) === null || _this$wager2 === void 0 ? void 0 : _this$wager2.minRowPrice);
    if (impossibleRows > 0) {
      setTimeout(() => {
        this.dialog = new svs.components.dialog.Confirm({
          actions: [{
            callback: () => {
              window.location.href = "".concat(svs.core.urlMapping.get('challengeMyBetsHome'), "/").concat(data.wagerClientSerial);
            },
            title: 'Till spelet'
          }, {
            title: 'Okej'
          }],
          branding: svs.components.dialog.branding.SPORT,
          icon: 'help-2',
          message: [{
            text: "Ditt system inneh\xF6ll ".concat(impossibleRows, " rad").concat(impossibleRows > 1 ? 'er' : '', "\n              med kombinationer som inte \xE4r m\xF6jliga att vinna p\xE5. Den nya systemkostnaden blev\n              ").concat(svs.utils.format.Currency(betAmount), " kr.<br />\n              <a class=\"impossible-rows-read-more\">Mer information</a>"),
            type: svs.components.dialog.message.TEXT
          }],
          title: 'Dina kombinationer går inte att vinna på'
        });
        svs.components.dialog.api.add(this.dialog);
        this.listenToReadMoreClick();
      });
    } else {
      const marketplaceAccount = getMarketplaceAccount();
      let marketPlaceUrl;
      if (marketplaceAccount) {
        marketPlaceUrl = svs.core.urlMapping.get('marketplace') + svs.components.marketplace.helpers.getTeamUrl(marketplaceAccount.groupId, marketplaceAccount.name, 'spel', marketplaceAccount.containerId, marketplaceAccount.activatedDrawId);
      }
      svs.components.sport.getPaymentDoneMessage({
        amount: betAmount,
        isRetailer: svs.challenge.data.isRetailerAdmin,
        marketplaceUrl: marketPlaceUrl,
        productName: 'Challenge'
      }, messageObject => {
        svs.components.dialog.api.add(new svs.components.dialog.Confirm(messageObject.paymentDoneDialogConfig));
      });
    }
    clearCoupon(draw.drawNumber);
    let roomKeys = [];
    if (draw.roomKeys) {
      roomKeys = draw.roomKeys;
    }
    if (data && data.wagerClientSerial) {
      svs.components.app_notifications.setUpAppNotifications({
        productId: svs.challenge.constants.PRODUCT_ID,
        roomKeys,
        wagerSerial: data.wagerClientSerial
      });
    }
    updateAccountBalance();
    this.setState({
      redirect: true
    });
    paymentSuccess();
  }
  onPayError(response) {
    const paymentFailed = this.props.paymentFailed;
    const errCodestr = String(response.error.code);
    const errCode = parseInt(errCodestr.replace(/\s/g, ''), 10);
    let errTitle = '';
    let errMessage = '';
    const marketplaceAccount = getMarketplaceAccount();
    switch (errCode) {
      case 2:
        if (marketplaceAccount) {
          errTitle = 'Minsta möjliga systemstorlek är 10kr';
        }
        break;
      case 100005:
        errTitle = 'Du har blivit utloggad. Vänligen logga in igen.';
        break;
      case 8124:
        errTitle = 'Omgången är stängd för spel, vänligen försök senare';
        break;
      case 8105:
        errTitle = 'Omgången har stängt';
        break;
      case 8107:
        errTitle = 'Omgången har inte öppnat för spel, vänligen försök senare';
        break;
      case 83:
        errTitle = 'Omöjlig spelkombination';
        errMessage = "Spelet gick inte att betala p\xE5 grund av att spelkombinationen inte \xE4r m\xF6jlig att vinna p\xE5.<br />\n            <a class=\"impossible-rows-read-more\">Mer information</a>";
        break;
      default:
    }
    svs.sport.sport_common.showErrorDialog(errTitle, errMessage);
    this.listenToReadMoreClick();
    log.debug("Error in payment: ".concat(response.error.code, ": ").concat(response.error.message));
    paymentFailed();
  }
  onClickImpossibleRows(e) {
    const openSpelguide = this.props.openSpelguide;
    e.preventDefault();
    openSpelguide();
    svs.components.dialog.api.close();
  }
  listenToReadMoreClick() {
    if (document.querySelector('.impossible-rows-read-more')) {
      document.querySelector('.impossible-rows-read-more').addEventListener('click', this.onClickImpossibleRows);
    }
  }
  render() {
    const redirect = this.state.redirect;
    if (redirect) {
      return React.createElement(Redirect, {
        push: true,
        to: ""
      });
    }
    return null;
  }
}


const _svs$challenge$helper = svs.challenge.helpers,
  getDrawByDrawNumber = _svs$challenge$helper.getDrawByDrawNumber,
  getCouponByDrawNumber = _svs$challenge$helper.getCouponByDrawNumber;
const mapStateToProps = (state, _ref) => {
  let match = _ref.match;
  const drawNumber = Number(match.params.drawNumber);
  return {
    boardData: svs.challenge.getBoardData(state, drawNumber),
    coupon: getCouponByDrawNumber(state, drawNumber),
    draw: getDrawByDrawNumber(drawNumber, state),
    isPaymentInitialized: state.isPaymentInitialized
  };
};
const _svs$challenge$action = svs.challenge.actions,
  openSpelguide = _svs$challenge$action.openSpelguide,
  clearCoupon = _svs$challenge$action.clearCoupon,
  paymentSuccess = _svs$challenge$action.paymentSuccess,
  paymentFailed = _svs$challenge$action.paymentFailed,
  cancelPayment = _svs$challenge$action.cancelPayment,
  receiveAccountBalance = _svs$challenge$action.receiveAccountBalance;
svs.challenge.PayWager = withRouter(ReactRedux.connect(mapStateToProps, {
  cancelPayment,
  clearCoupon,
  openSpelguide,
  paymentFailed,
  paymentSuccess,
  updateAccountBalance: receiveAccountBalance
})(PayWager));

 })(window);